import React from 'react';
import './LegalPage.css';

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Last Updated: February 2026</p>

        <p>
          This Privacy Policy describes how the SMPW Masters Event Scheduling Team
          ("we," "us," or "our") collects, uses, and protects your personal information
          in connection with volunteer coordination for the 2026 Augusta Masters SMPW Event.
        </p>

        <h2>Information We Collect</h2>
        <p>We collect the following personal information you voluntarily provide when registering as a volunteer or driver:</p>
        <ul>
          <li>First and last name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Congregation affiliation</li>
          <li>Availability and scheduling preferences</li>
          <li>Vehicle information (for drivers)</li>
        </ul>

        <h2>How We Use Your Information</h2>
        <p>Your information is used solely for event coordination purposes, including:</p>
        <ul>
          <li>Scheduling volunteers and drivers for cart witnessing shifts</li>
          <li>Sending availability request links via SMS or email</li>
          <li>Notifying you of confirmed shift assignments</li>
          <li>Communicating urgent changes due to weather conditions or other emergencies</li>
          <li>Coordinating check-in and day-of operations</li>
        </ul>

        <h2>SMS Communications</h2>
        <p>
          By providing your phone number, you consent to receive SMS text messages from the
          SMPW Masters Event Scheduling Team for the purposes described above. Message frequency
          will vary based on event scheduling needs.
        </p>
        <p><strong>Message and data rates may apply.</strong></p>
        <p>
          To opt out of SMS messages at any time, reply <strong>STOP</strong> to any message
          you receive from us. You may also reply <strong>HELP</strong> for assistance.
          Opting out of SMS will not affect your volunteer registration.
        </p>

        <h2>Data Sharing</h2>
        <p>
          We do not sell, rent, or share your personal information — including your phone
          number — with any third parties for marketing or commercial purposes. Your
          information is accessible only to authorized event coordinators and scheduling
          administrators.
        </p>

        <h2>Data Retention</h2>
        <p>
          Your information is retained for the duration of the event and for a reasonable
          period afterward for record-keeping purposes. You may request deletion of your
          information by contacting us directly.
        </p>

        <h2>Security</h2>
        <p>
          We take reasonable measures to protect your personal information from unauthorized
          access or disclosure. Volunteer data is stored in a secured cloud database accessible
          only to event administrators.
        </p>

        <h2>Contact</h2>
        <p>
          If you have questions about this Privacy Policy or wish to request removal of your
          information, please contact a member of your congregation's Service Committee.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
